define('C3.ShoppingExtensions.NewArrivals.Collection',
  [
  'C3.ShoppingExtensions.NewArrivals.Model',
  'Utils',
  'SCCollection',
  'SCModel',
  'underscore'
  ],
  function (NewArrivalsModel, Utils,SCCollectionModule,SCModelModule,_) {
    'use strict';

     var SCCollection = SCCollectionModule.SCCollection;
     var SCModel = SCModelModule.SCModel;


     function NewArrivalsCollection(models, options) {
      SCCollection.call(this, models, options);

      this.model = SCModel;

      this.customFilters = options && options.filters;


      this.url = function url () {
        return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "services/NewArrivals.Service.ss"
                )
              )
      }

       this.parse = function parse(response) {
        this.totalRecordsFound = response.totalResultsCount;
        this.recordsPerPage = 50;

        var newArrivalData = response.newArrivalData
       // console.log(response)
        return newArrivalData.items;
      }

      this.update = function update(options){
         const data = {
              filter: options.filter,
              pageNumber: options.page || 1,
              resultsPerPage: options.resultsPerPage || 50,
              keyword : options.keyword
          };

         // console.log(data)
          
          this.fetch({
              data: data,
              reset: true,
              killerId: options.killerId
          });
      }
    }

    NewArrivalsCollection.prototype = Object.create(SCCollection.prototype);
    NewArrivalsCollection.prototype.constructor = NewArrivalsCollection;

    return NewArrivalsCollection;
    
  }
);
